import { Link } from 'react-router-dom';
import { usePaginatedOrderListQuery } from '../../api/generated';
import '../../styles/notification.css';
import '../../styles/ProfileBar.css';
import Percent from './PercentBar';

export default function Notifa() {
    const { data } = usePaginatedOrderListQuery();
    const total = data?.paginatedOrderList?.totalRows;
    const dataset = data?.paginatedOrderList?.orderList;
    let done = 0;
    let overdue = 0;
    let cancelled = 0;
    dataset?.map((row) => (row?.orderStatus === 'Done' ? done++ : done));
    dataset?.map((row) =>
        row?.orderStatus === 'Overdue' ? overdue++ : overdue
    );
    dataset?.map((row) =>
        row?.orderStatus === 'Cancelled' ? cancelled++ : cancelled
    );
    const percentTotal = String((Number(total) / (Number(total) + 10)) * 100);
    const percentDone = String((Number(done) / (Number(done) + 10)) * 100);
    const percentOverdue = String(
        (Number(overdue) / (Number(overdue) + 10)) * 100
    );
    const percentCancelled = String(
        (Number(cancelled) / (Number(cancelled) + 10)) * 100
    );

    return (
        <div className="notifa max-w-sm rounded-lg ">
            <div className="px-6 py-4">
                <div className="headerTitle font-bold text-xl mb-2 grid grid-cols-2 ">
                    Orders
                    <div className="pl-36">
                        <Link to="/admin/order-list">
                            <svg
                                width="31"
                                height="30"
                                viewBox="0 0 31 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    x="0.493164"
                                    width="30"
                                    height="30"
                                    rx="5"
                                    fill="#5570F1"
                                />
                                <path
                                    d="M17.2031 23.5598L24.7331 16.0638C25.2991 15.4998 25.2991 14.5018 24.7331 13.9358L17.2031 6.43983C16.6151 5.85583 15.6651 5.85783 15.0811 6.44583C14.4971 7.03383 14.4971 7.98183 15.0851 8.56783L20.0391 13.5018H7.3291C6.4991 13.5018 5.8291 14.1738 5.8291 15.0018C5.8291 15.8298 6.4991 16.5018 7.3291 16.5018H20.0391L15.0851 21.4338C14.7911 21.7278 14.6451 22.1118 14.6451 22.4978C14.6451 22.8798 14.7911 23.2638 15.0811 23.5558C15.6651 24.1418 16.6151 24.1438 17.2031 23.5598Z"
                                    fill="white"
                                />
                            </svg>
                        </Link>
                    </div>
                </div>
                <Percent
                    bgcolor="blue"
                    progress={percentTotal}
                    height={10}
                    name="Total"
                    numbre={Number(total)}
                />

                <Percent
                    bgcolor="green"
                    progress={percentDone}
                    height={10}
                    name="Done"
                    numbre={done}
                />

                <Percent
                    bgcolor="orange"
                    progress={percentOverdue}
                    height={10}
                    name="Overdue"
                    numbre={overdue}
                />

                <Percent
                    bgcolor="red"
                    progress={percentCancelled}
                    height={10}
                    name="Cancelled"
                    numbre={cancelled}
                />
            </div>
        </div>
    );
}
